import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { AuthenticationService, IWebAppUser, } from '@services/authentication.service';
import { combineLatest, firstValueFrom, Subject } from 'rxjs';
import { takeUntil, distinctUntilChanged, filter, finalize } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { IOrganisation } from '@services/organisation-data.service';
import { IIntegratonType, IntegrationsService, IWebhookIntegraton } from '@services/integrations.service';
import { Account, IAccount } from '@services/accounts.service';
import { EditWebhookIntegrationNeuronSensorComponent } from 'src/app/dialogs/edit-webhook-integration-neuronsensor/edit-webhook-integration-neuronsensor.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { convertEpochToDateString, generateGUID } from '@functions/functions';
import { EditWebhookIntegrationComponent } from 'src/app/dialogs/edit-webhook-integration/edit-webhook-integration.component';
import { ComponentType } from '@angular/cdk/portal';
import { NeuronsensorsService, nsWebhookConfig } from '@services/neuronsensors.service';
import { ExecOptions } from 'node:child_process';

@Component({
	selector: 'app-data-integrations',
	templateUrl: './data-integrations.component.html',
	styleUrls: ['./data-integrations.component.scss']
})
export class DataIntegrationsComponent implements OnInit, OnDestroy {

	@ViewChild('outlet') outlet: RouterOutlet;

	/** Route Organisation ID */
	public routeOrganisationID: string

	/** Selected Organisation */
	public selectedOrganisation: IOrganisation

	/** Selected Account GUID */
	public selectedAccountGUID: string

	/** Selected Account */
	public selectedAccount: IAccount

	/** Array of Webhooks */
	public webhookIntegrations: IWebhookIntegraton[]

	/** Array of Webhooks */
	public filteredWebhookIntegrations: IWebhookIntegraton[]

	/** Array of Webhook Types */
	public webhookIntegrationTypes: IIntegratonType[]

	/** Array of Webhook Types */
	public webhookIntegrationTypesAll: IIntegratonType[]

	/** Webhook Types */
	public webhookTypes: { [key: string]: any } = {}

	/** Webhooks Loaded */
	public WebhooksLoaded: boolean

	/** Array of Neuron Sensors Webhooks */
	public webhookNeuronSensor: IWebhookIntegraton[]

	/** Array of Omron Webhooks */
	public webhookOmron: IWebhookIntegraton[]

	/** Current User */
	public currentUser: IWebAppUser

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** Selected Integration ID */
	public selectedIntegrationID: string = "";

	/** Selected Integration */
	public selectedIntegration?: IWebhookIntegraton

	// set the value to select an item based on mapped value at initial rendering
	private ShowWebhooksKey: string = this.constructor.name + "_showWebhooks"
	public showWebhooks: string = localStorage.getItem(this.ShowWebhooksKey) || "1";

	// define the JSON of data for th eButton Group
	public BGSelection: {
		Id: string;
		Value: string;
		Text: string;
		Icon: string;
		Color: string;
	}[] = [
			{ Id: '1', Value: 'All', Text: 'Showing All Webhooks', Icon: '', Color: '' },
			{ Id: '2', Value: 'Enabled', Text: 'Showing Only Enabled Webhooks', Icon: 'toggle_on', Color: 'green' },
			{ Id: '3', Value: 'Disabled', Text: 'Showing Only Disabled Webhooks', Icon: 'toggle_off', Color: 'red' }
		];

	// maps the appropriate column to fields property
	public fields: Object = { text: 'Value', value: 'Id' };
	// set the height of the popup element
	public height: string = '220px';
	// set the placeholder to DropDownList input element
	public waterMark: string = 'Select';

	/** selectedTab */
	public selectedTab: number = 0

	public NeuronSensorArray: nsWebhookConfig[]
	private validationCache = new Map<string, nsWebhookConfig>();

	/**
	 * Default Constructor
	 * @param globalFunctions Global Functions
	 * @param authenticationService Authentication Services
	 * @param activatedRoute ActivatedRoute
	 * @param siteSubscriptions Site Subscriptions
	 * @param integrationService integrationService
	 * @param router router
	 * @param dialog MatDialog
	 */
	constructor(
		private globalFunctions: GlobalFunctions,
		public authenticationService: AuthenticationService,
		private activatedRoute: ActivatedRoute,
		private siteSubscriptions: siteSubscriptions,
		private integrationService: IntegrationsService,
		private router: Router,
		public dialog: MatDialog,
		private clipboard: Clipboard,
		private neuronsensorsService: NeuronsensorsService
	) {

		const childRoute = this.getChildRoute(this.activatedRoute);

		combineLatest([
			// Validate the user
			this.authenticationService.currentUser$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.selectedAccount$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.myOrganisations$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.activatedRoute.paramMap.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.activatedRoute.queryParamMap.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			// Deepest child parameters
			childRoute.paramMap.pipe(takeUntil(this.finalise), distinctUntilChanged())

		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([currentUser, account, myOrganisations, paramMap, queryParamMap, childparamMap]) =>
				!!currentUser && !!account && !!myOrganisations && !!paramMap && !!queryParamMap)
		).subscribe({
			next: ([currentUser, account, myOrganisations, paramMap, queryParamMap, childparamMap]) => {
				// Check we have a validated User
				if (currentUser && !this.currentUser) {
					this.currentUser = <IWebAppUser>currentUser
				}
				// Check we have a validated User
				if (account && this.selectedAccount == undefined) {
					this.selectedAccount = account;
					this.selectedAccount = this.siteSubscriptions.normalizeFeatures(this.selectedAccount) as Account;
					this.selectedAccountGUID = this.selectedAccount.GUID;
				}

				this.selectedIntegrationID = childparamMap.get('integrationID') || ''

				// Get the GUID for the selected Account to Manage				
				if (this.routeOrganisationID != paramMap.get('organisation')) {
					this.routeOrganisationID = paramMap.get('organisation') || ""
					if (this.routeOrganisationID != "") {
						let organisationsList = myOrganisations;
						this.selectedOrganisation = <IOrganisation>organisationsList.find(({ Uid }) => Uid.toUpperCase() === this.routeOrganisationID.toUpperCase())
						this.getWebhookIntegrationTypes(this.selectedAccountGUID, this.selectedOrganisation.Uid)
					}
				}
				let isNeuron = queryParamMap.get("isneuron");
				if (isNeuron) {
					if (isNeuron == 'true') {
						this.selectedTab = 0;
					} else if (isNeuron == 'false') {
						this.selectedTab = 1;
					}
				}

			},
			error: (error) => {
				this.globalFunctions.HandleError(error, `Error: ${this.constructor.name} → combineLatest`, false);
			}
		})
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.globalFunctions.displaySpinner(true);
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	};

	/**
	 * Page after view init Event Handler
	 */
	ngAfterViewInit() { }

	/**
	 * getChildRoute
	 * @param route 
	 * @returns 
	 */
	private getChildRoute(route: ActivatedRoute): ActivatedRoute {
		while (route.firstChild) {
			route = route.firstChild;
		}

		return route;
	}

	/**
	 * ValidateNeuron
	 * @param integration 
	 * @returns 
	 */
	ValidateNeuron(integration: IWebhookIntegraton): string {

		if (integration.NeuronSensors) {
			if (this.validationCache.has(integration.ClientWebhookID)) {
				var fred = this.validationCache.get(integration.ClientWebhookID);
				if (fred) {
					if (fred.disabled >= 100)
						return "Disabled"
					else if (fred.disabled >= 50 && fred.disabled < 100)
						return "Warning"
					else
						return "OK"
				} else {
					return ""
				}
			}
		}
		return "";
	}

	/**
	 * getWebhooks
	 * @param integration 
	 * @returns 
	 */
	async getWebhooks(integration: IWebhookIntegraton): Promise<nsWebhookConfig | undefined> {

		var apiKey = integration.NeuronSensorAPI
		var systemID = integration.NeuronSensorSystem
		var webhookID = integration.ClientWebhookID

		try {
			const integration = await firstValueFrom(this.neuronsensorsService
				.getIntegrationByID$(apiKey, systemID, webhookID)
				.pipe(
					filter((integrations) => !!integrations)
				)
			);

			return integration

		} catch (error: any) {
			if (error.status != 404){
				console.error("Error fetching webhooks:", error);
			}
			return undefined;
		}

	}

	/**
	 * convertEpoch
	 * @param epoch
	 * @returns
	 */
	convertEpoch(epoch: number): string {
		/** Use the Global Function */
		return convertEpochToDateString(epoch);
	};

	/**
	 * Refresh Location
	 */
	refresh() {
		this.router.navigate(['.'], { relativeTo: this.activatedRoute });
	};

	/** SelectRow */
	SelectRow(integration: IWebhookIntegraton) {
		this.selectedIntegration = integration
	};

	/**
	 * toggleButtonGroupFilter
	 * @param show 
	 */
	toggleButtonGroupFilter(show: string): void {
		this.showWebhooks = show;
		localStorage.setItem(this.ShowWebhooksKey, this.showWebhooks);
		this.updateWebhookLists(this.showWebhooks)
	}

	/**
	 * getWebhookIntegrationTypes
	 * @param accountGUID
	 * @param organisationUID
	 */
	async getWebhookIntegrationTypes(accountGUID: string, organisationUID: string) {

		let params = {
			"accountGUID": accountGUID,
			"organisationUID": organisationUID
		}

		try {
			const integrationTypes = await firstValueFrom(
				this.integrationService.getWebhookIntegrationTypes$(params).pipe(
					filter((integrationTypes) => !!integrationTypes))
			);

			if (integrationTypes) {
				this.webhookIntegrationTypes = <IIntegratonType[]>integrationTypes
				this.getWebhookIntegrations(this.selectedAccountGUID, this.selectedOrganisation.Uid)
			}
		}
		catch (error) {
			console.log(error);
			this.globalFunctions.HandleError(error, `Error: ${this.constructor.name} → this.integrationService.getWebhookIntegrationTypes$`, false);
		}

	};

	/**
	 * Get the Integrations for the Account Organisation filtered by Type
	 * @param accountGUID
	 * @param organisationUID
	 * @param typeID
	 */
	async getWebhookIntegrations(accountGUID: string, organisationUID: string, typeID: number = 0) {

		let queryParams = {
			"typeID": typeID
		}

		try {
			const integrations = await firstValueFrom(
				this.integrationService.getWebhookIntegrations$(accountGUID, organisationUID, "", queryParams).pipe(
					filter((integrations) => !!integrations))
			);

			if (integrations) {
				// Get the GUID for the selected Account to Manage
				this.webhookIntegrations = <IWebhookIntegraton[]>integrations
				this.updateWebhookLists(this.showWebhooks)
				this.WebhooksLoaded = true;

				if (this.selectedIntegrationID != "") {
					this.selectedIntegration = this.webhookIntegrations.find((x: IWebhookIntegraton) => x.WebhookUID == this.selectedIntegrationID);
				}

				this.NeuronSensorArray = [] as nsWebhookConfig[]

				// 🔹 Validate each integration asynchronously (non-blocking)
				for (const integration of this.webhookIntegrations) {
					if (integration.NeuronSensors) {
						var rtn = await this.getWebhooks(integration); // no await -> fire and forget
						if (rtn) {
							this.validationCache.set(rtn.id, rtn);
						}
					}
				}
			}
		}
		catch (error) {
			console.log(error);
			this.globalFunctions.HandleError(error, `Error: ${this.constructor.name} → this.integrationService.getWebhookIntegrations$`, false);
		} finally {
			this.globalFunctions.displaySpinner(false);
		}

	};

	/**
	 * toggleChange
	 * @param event 
	 * @param integration 
	 */
	// toggleChange(args: MatSlideToggleChange, integration: IWebhookIntegraton) {
	toggleChange(event: MouseEvent, integration: IWebhookIntegraton) {

		// Prevent the toggle from changing immediately
		event.preventDefault();
		event.stopPropagation();

		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Check if webhook is enabled
		const enabled = integration.Enabled;
		this.globalFunctions.UserConfirm$(`${enabled ? "Disable" : "Enable"} ${integration.Description} webhook?`, `${enabled ? "Disable" : "Enable"} Webhook`, "Yes", "No")
			.subscribe(confirmed => {
				if (confirmed) {
					integration.Enabled = !integration.Enabled
					this.integrationService.patchWebhookIntegration$(this.selectedAccountGUID, this.selectedOrganisation.Uid, integration.OrganisationWebhookID, integration).pipe(
						takeUntil(fetchDataSubject), distinctUntilChanged(),
						filter((integrations) => !!integrations),
						finalize(() => {
							// Ensure the subscription is terminated and the subject is completed
							fetchDataSubject.next();
							fetchDataSubject.complete();
						})
					).subscribe({
						next: (integrations) => {

							let data = <IWebhookIntegraton>integrations
							Object.assign(integration, data);

							if (data.Enabled) {
								this.globalFunctions.DisplaySnackBar({ message: `Webhook ${data.Description} had been Enabled`, action: "" })
								if (data.NeuronSensors) {
									this.globalFunctions.UserConfirm$(`Re-Enable Webhook in Neuron Sensors?`, "Enable NeuronSensors", "Yes", "No")
										.subscribe(confirmed => {
											if (confirmed) {
												var nsIntegration = {} as nsWebhookConfig
												nsIntegration.id = data.ClientWebhookID
												nsIntegration.type = "POST"
												nsIntegration.disabled = 0
												this.patchWebhook(data.NeuronSensorAPI, data.NeuronSensorSystem, nsIntegration)
											}
										});
								}
							}
							else {
								this.globalFunctions.DisplaySnackBar({ message: `Webhook ${data.Description} had been Disabled`, action: "" })
								if (data.NeuronSensors) {
									// If deleted or Not Enabled, then automatically disable the Webhook
									var nsIntegration = {} as nsWebhookConfig
									nsIntegration.id = data.ClientWebhookID
									nsIntegration.type = "POST"
									nsIntegration.disabled = 150
									this.patchWebhook(data.NeuronSensorAPI, data.NeuronSensorSystem, nsIntegration)
								}
							}
						},
						error: (error) => { this.globalFunctions.HandleError(error, "patchWebhookIntegration Error: Patching Integrations", false) },
						//complete: () => {console.log("patchWebhookIntegration: Patching Integrations: Complete");}
					});
				}
			})
	};

	/**
	 * updateWebhookLists
	 * @param showWebhooks 
	 */
	updateWebhookLists(showWebhooks: string) {

		if (this.webhookIntegrations) {
			for (const integration of this.webhookIntegrationTypes) {
				let typeID = integration.WebhookTypeID
				try {

					this.webhookTypes[typeID] = {}

					let result = this.webhookIntegrations.filter(({ WebhookTypeID }) => WebhookTypeID == typeID)

					if (showWebhooks == "1") {
						result = result;
					} else if (showWebhooks == "2") {
						result = result.filter((webhook) => webhook.Enabled == true);
					} else if (showWebhooks == "3") {
						result = result.filter((webhook) => webhook.Enabled == false);
					}

					this.webhookTypes[typeID] = { webhooks: result }
				}
				catch (error) {
					// console.log(error);
				};
			};
		};
	};

	/**
	 * addIntegration
	 * @param typeID 
	 */
	addIntegration(typeID: number) {

		// alert("Add a new Webhook Integration: Not Implemeneted Yet");

		let integrationType = <IIntegratonType>this.webhookIntegrationTypesAll.find(({ WebhookTypeID }) => WebhookTypeID == typeID)
		let WebhookUID = generateGUID()
		// Create a 'Local' copy of the integration Information
		var _edit = <IWebhookIntegraton>{
			AccountUID: this.selectedAccountGUID,
			OrganisationWebhookID: 0,
			OrganisationID: this.selectedOrganisation.Id,
			OrganisationUID: this.selectedOrganisation.Uid,
			WebhookID: 0,
			WebhookUID: WebhookUID,
			ClientWebhookID: "",
			Host: (integrationType.Host),
			Path: (integrationType.Path + WebhookUID),
			FQN: (integrationType.Host + integrationType.Path),
			Description: "",
			AutoBuild: false,
			Enabled: true,
			WebhookTypeID: integrationType.WebhookTypeID,
			Type: integrationType.Type,
			TypePath: integrationType.Path,
			TypeDescription: integrationType.Description,
			TypeAzureCode: integrationType.AzureCode,
			Deleted: false,
			SensorCount: 0,
			SensorOnlineCount: 0,
			DatapointCount: 0,
			DatapointOnlineCount: 0,
			NeuronSensorAPI: "",
			NeuronSensorSystem: "",
			NeuronSensors: integrationType.NeuronSensors
		};

		// Choose the dialog component
		const component: ComponentType<any> = _edit.NeuronSensors
			? EditWebhookIntegrationNeuronSensorComponent
			: EditWebhookIntegrationComponent;

		// Display the dialog box
		const dialogRef = this.dialog.open(component, { data: _edit });

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// Create a local Subject to control the subscription lifecycle
			const fetchDataSubject = new Subject<void>();

			// console.log('The dialog was closed');
			// Check we have a result to work with
			this.globalFunctions.displaySpinner(true)
			Object.assign(_edit, result);
			this.integrationService.postWebhookIntegration$(this.selectedAccountGUID, this.selectedOrganisation.Uid, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((integrations) => !!integrations),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
					this.globalFunctions.displaySpinner(false);
				})
			).subscribe({
				next: (integrations) => {
					let data = <IWebhookIntegraton>integrations
					this.globalFunctions.DisplaySnackBar({ message: `Webhook ${data.Description} had been Added`, action: "" })
					this.getWebhookIntegrationTypes(this.selectedAccountGUID, this.selectedOrganisation.Uid)

					// If deleted or Not Enabled, then automatically disable the Webhook
					if (data.Deleted || !data.Enabled) {
						var nsIntegration = {} as nsWebhookConfig
						nsIntegration.id = data.ClientWebhookID
						nsIntegration.type = "POST"
						nsIntegration.disabled = 150
						this.patchWebhook(data.NeuronSensorAPI, data.NeuronSensorSystem, nsIntegration)
					}

				},
				error: (error) => { this.globalFunctions.HandleError(error, "patchWebhookIntegration Error: Patching Integrations", false) },
				//complete: () => {console.log("patchWebhookIntegration: Patching Integrations: Complete");}
			});
		});

	};

	/**
	 * editIntegration
	 * @param integration 
	 */
	editIntegration(integration: IWebhookIntegraton) {

		// Create a 'Local'/shallow copy of the integration Information
		var _edit = { ...integration }

		//Pre populate this 
		if (!_edit.AccountUID || _edit.AccountUID == "") {
			_edit.AccountUID = this.selectedAccountGUID
		}

		// Choose the dialog component
		const component: ComponentType<any> = _edit.NeuronSensors
			? EditWebhookIntegrationNeuronSensorComponent
			: EditWebhookIntegrationComponent;

		// Display the dialog box
		const dialogRef = this.dialog.open(component, { data: _edit });

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// Create a local Subject to control the subscription lifecycle
			const fetchDataSubject = new Subject<void>();

			// console.log('The dialog was closed');
			// Check we have a result to work with
			this.globalFunctions.displaySpinner(true)
			Object.assign(_edit, result);
			this.integrationService.patchWebhookIntegration$(this.selectedAccountGUID, this.selectedOrganisation.Uid, _edit.OrganisationWebhookID, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
					this.globalFunctions.displaySpinner(false);
				})
			).subscribe({
				next: (integrations) => {
					let data = <IWebhookIntegraton>integrations
					Object.assign(integration, data);
					this.globalFunctions.DisplaySnackBar({ message: `Webhook ${data.Description} had been Updated`, action: "" })

					// If deleted or Not Enabled, then automatically disable the Webhook
					if (data.Deleted || !data.Enabled) {
						var nsIntegration = {} as nsWebhookConfig
						nsIntegration.id = data.ClientWebhookID
						nsIntegration.type = "POST"
						nsIntegration.disabled = 150
						this.patchWebhook(data.NeuronSensorAPI, data.NeuronSensorSystem, nsIntegration)
					}
				},
				error: (error) => { this.globalFunctions.HandleError(error, "patchWebhookIntegration Error: Patching Integrations", false) },
				//complete: () => {console.log("patchWebhookIntegration: Patching Integrations: Complete");}
			});
		});

	};

	/**
	 * patchWebhook
	 * @param apiKey 
	 * @param systemID 
	 * @param _edit 
	 */
	patchWebhook(apiKey: string, systemID: string, _edit: nsWebhookConfig) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();
		this.neuronsensorsService.patchIntegration$(apiKey, systemID, _edit).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((success) => !!success),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (success) => {

			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error patching Webhook", true);
			}
		})
	}

	/**
	 * deleteIntegration
	 * @param integration 
	 */
	deleteIntegration(integration: IWebhookIntegraton) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.globalFunctions.UserConfirm$(`Delete ${integration.Description} webhook?`, `Delete Webhook`, "Yes", "No")
			.subscribe(confirmed => {
				if (confirmed) {
					this.integrationService.deleteWebhookIntegration$(this.selectedAccountGUID, this.selectedOrganisation.Uid, integration.OrganisationWebhookID).pipe(
						takeUntil(fetchDataSubject), distinctUntilChanged(),
						filter((result) => !!result),
						finalize(() => {
							// Ensure the subscription is terminated and the subject is completed
							fetchDataSubject.next();
							fetchDataSubject.complete();
						})
					).subscribe({
						next: (result) => {
							this.globalFunctions.DisplaySnackBar({ message: "Webhook Deleted", action: "" })
							this.getWebhookIntegrationTypes(this.selectedAccountGUID, this.selectedOrganisation.Uid)
						},
						error: (error) => { this.globalFunctions.HandleError(error, "deleteWebhookIntegration Error: Deleting Integrations", false) },
					})
				}
			});
	};

	/**
	 * copy To Clipboard
	 * @param integration
	 */
	copyToClipboard(integration: IWebhookIntegraton) {
		try {
			let text = integration.FQN;
			if (this.clipboard.copy(text)) {
				this.globalFunctions.DisplaySnackBar({
					message: "Path copied to clipboard",
					action: "",
					duration: 2000
				});
			};
		} catch (error) { console.error(error); }
	};

}
